import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import OrdersDash from "./OrdersDash";
import HelpRequest from "./HelpRequest";
import axios from "axios";

export default function AdminDash() {
  const [User, setUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isManager, setIsManager] = useState(false);
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);
  useEffect(() => {
    async function getUser() {
      try {
        const response = await axios.get(
          `https://cityflat.onrender.com/user/${User.id}`
        );
        const user = response.data;
        setIsAdmin(user.role === "ADMIN");
        setIsManager(user.role === "MANAGER");
      } catch (error) {
        console.error(error);
      }
    }

    if (User) {
      getUser();
    }
  }, [User]);

  const [showHelpModal, setShowHelpModal] = useState(false);

  const handleShowHelpModal = () => setShowHelpModal(true);
  const handleCloseHelpModal = () => setShowHelpModal(false);

  return (
    <>
      {isAdmin || isManager ? (
        <>
          <Sidebar onHelpClick={handleShowHelpModal} />
          <OrdersDash />
          <HelpRequest show={showHelpModal} onHide={handleCloseHelpModal} />
        </>
      ) : (
        <div className="div-denied bg-dark d-flex align-items-center justify-content-center">
          <h1 className="text-warning text-center display-1">
            ⚠️ 404 NOT FOUND
          </h1>
        </div>
      )}
    </>
  );
}
